/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccessType,
  AnchorType,
  ContentHistoryEntryDto,
  ContentRollbackRequestDto,
  OrderRequestDto,
  ProblemDetails,
  ProjectAndScenePermissionsResponseDto,
  QueryFlagType,
  SceneAccessorRequestDto,
  SceneAccessorResponseDto,
  SceneActionRequestDto,
  SceneContentCollectionDto,
  SceneContentResponseDto,
  SceneCopyRequestDto,
  SceneFileResponseDto,
  SceneResponseDto,
  TeamProjectShareRequestDto,
  TransferRequestDto,
  UserSceneShareRequestDto,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Scenes<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description This endpoint retrieves a list of scenes with various filtering options. You can filter scenes by the user's team, or by geographic location (latitude and longitude). If no filters are provided, all scenes that are active or public will be returned. If a location is provided, only scenes within a specified distance will be included. **Filtering options:** - **teamId**: Filters the scenes to only those associated with the given team ID. - **latitude & longitude**: Filters scenes to those within a specified distance from the provided coordinates. - If both teamId and location are provided, the results will be filtered by both criteria. - If neither filter is provided, all active or public scenes will be returned. **Restrictions:** - Latitude and Longitude should not be equal to 0.0. Providing invalid coordinates will result in a `400 BadRequest` response. - If the teamId is provided but the user is not associated with the team, the request will return `400 BadRequest`. - The scene retrieval is limited to active or public scenes (depending on the user’s role and permissions). - **SuperAdmin** can view all scenes, regardless of team association, as long as the scenes are not deleted. No further filtering restrictions apply to SuperAdmins. **Outcome:** - On success, returns HTTP 200 OK with a list of scene response DTOs. - If any input parameters are invalid (e.g., incorrect latitude/longitude, unauthorized access), it returns HTTP `400 BadRequest`. - On internal server errors, it returns HTTP 500 Internal Server Error.
   *
   * @tags Scenes
   * @name ScenesList
   * @summary Get all scenes, optionally filtered by team and location
   * @request GET:/scenes
   * @secure
   */
  scenesList = (
    query?: {
      /** @format double */
      latitude?: number;
      /** @format double */
      longitude?: number;
      /** @format int32 */
      distance?: number;
      queryFlag?: QueryFlagType;
    },
    params: RequestParams = {},
  ) =>
    this.request<SceneResponseDto[], ProblemDetails | void>({
      path: `/scenes`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint creates a new scene with details provided in the request. The scene can be associated with a team and may include location and image information. **Restrictions:** - **Team Validation**: The user must belong to the team provided in the request, and their role must not be `Viewer`. - **Location Validation**: If the `AccessType` is `Location`, the latitude and longitude must be provided, and the anchor type must be `Image`. - **Image Validation**: If an image is provided, it must not be null or empty. The image will be uploaded to Azure Blob Storage, and the upload must succeed for the scene to be created. **Outcome:** - On success, returns HTTP 200 OK with a `SceneResponseDto` containing the newly created scene details. - If the request is invalid (e.g., missing required fields or invalid permissions), returns HTTP 400 Bad Request. - If the user lacks permission (e.g., has `Viewer` role in the team), returns HTTP `400 BadRequest`. Requires Editor or Owner permission in the team. Viewers cannot create scenes.
   *
   * @tags Scenes
   * @name ScenesCreate
   * @summary Insert a new scene
   * @request POST:/scenes
   * @secure
   */
  scenesCreate = (
    data: {
      Name: string;
      Description?: string;
      ActivationStatus?: string;
      /** @format uuid */
      TeamId: string;
      /** @format double */
      ImageWidth?: number;
      /** @format binary */
      Image?: File;
      Tags?: string[];
      AccessType: AccessType;
      AnchorType: AnchorType;
      Address?: string;
      /** @format double */
      Latitude?: number;
      /** @format double */
      Longitude?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<SceneResponseDto, ProblemDetails | void>({
      path: `/scenes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint allows updating the details of an existing scene. The scene can be updated with new image, team association, and other attributes. The user must have sufficient permissions within the specified team to perform the update. **Restrictions:** - **Scene Existence**: The scene must exist in the database. If not, a `400 BadRequest` is returned. - **Team Validation**: The specified team must exist. If not, a `400 BadRequest` is returned. - **Permission Validation**: The user must have permission to update the scene in the given team. If the user has `Viewer` permissions, a `400 BadRequest` is returned. - **Image Validation**: If an image is provided, it will be uploaded to Azure Blob Storage. The upload must succeed for the update to be saved. If the upload fails, a `500 InternalServerError` is returned. **Outcome:** - On success, returns HTTP 200 OK with the updated scene details. - If the request is invalid (e.g., missing scene or team), returns HTTP 400 Bad Request. - If the user lacks permission (e.g., has `Viewer` role), returns HTTP `400 BadRequest`. Requires Editor or Owner permission in the team.
   *
   * @tags Scenes
   * @name ScenesPartialUpdate
   * @summary Update an existing scene
   * @request PATCH:/scenes/{sceneId}
   * @secure
   */
  scenesPartialUpdate = (
    sceneId: string,
    data: {
      /** @format uuid */
      TeamId: string;
      Name: string;
      Description?: string;
      ActivationStatus?: string;
      /** @format double */
      ImageWidth?: number;
      /** @format binary */
      Image?: File;
      Tags?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<SceneResponseDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description This endpoint allows deleting an existing scene. The scene will be marked as deleted, and its associated projects and resources will be cleaned up. The user must have sufficient permissions in the team to perform the deletion. **Restrictions:** - **Scene Validation**: The scene must exist and not be deleted. If the scene is not found or is already deleted, a `400 BadRequest` is returned with the `SceneNotFound` message. - **Team Validation**: The specified team must be valid, and the user must have sufficient permissions (i.e., not `Viewer`). If the team or permissions are invalid, a `400 BadRequest` is returned with the `YouHaveNoPermission` message. - **Project Cleanup**: If the scene is associated with a project, and if it's the last scene in that project, the project and associated resources will also be deleted. **Outcome:** - On success, the scene will be marked as deleted, and HTTP `204 No Content` is returned. - If the request is invalid (e.g., missing scene or team), returns HTTP `400 BadRequest`. - If the user lacks permission (e.g., has `Viewer` role), returns HTTP `400 BadRequest`. Requires Editor or Owner permission in the team.
   *
   * @tags Scenes
   * @name ScenesDelete
   * @summary Delete a scene
   * @request DELETE:/scenes/{sceneId}
   * @secure
   */
  scenesDelete = (
    sceneId: string,
    data: SceneActionRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/scenes/${sceneId}`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description This endpoint allows retrieving details of a specific scene using either its `sceneId` (UUID) or `ShortCode` (a unique string identifier). If the scene exists and is not deleted, the scene details will be returned. **Restrictions:** - **Scene Validation**: The scene must exist and not be deleted. If the scene is not found or is deleted, a `400 BadRequest` is returned with the `SceneNotFound` message. - **Accessors Information**: The scene will include its associated `SceneAccessors` data (if any) in the response. - **Attachment Check**: The response will also indicate whether the scene is attached to any project via the `IsAttached` flag, based on whether the scene is associated with any projects. **Outcome:** - On success, HTTP `200 OK` is returned with the scene details in the `SceneResponseDto` format. - If the scene is not found or invalid, HTTP `400 BadRequest` is returned with the `SceneNotFound` message. - If an internal error occurs during the process, HTTP `500 InternalServerError` is returned.
   *
   * @tags Scenes
   * @name ScenesDetail
   * @summary Get details of a scene
   * @request GET:/scenes/{sceneId}
   * @secure
   */
  scenesDetail = (sceneId: string, params: RequestParams = {}) =>
    this.request<SceneResponseDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Reassigns ownership of the scene to the target team. Pending invitations on the scene are cleared. Published scenes are temporarily unpublished and re-published only if the destination team's activation quota allows. **Restrictions:** A scene that belongs to a project cannot be transferred standalone — transfer the project instead. **Permissions:** SuperAdmin can transfer any scene. Regular users must be the creator owner (IsCreator) of both the source scene's team and the destination team. **Returns:** `204 No Content` on success. **Error Codes:** `400 BadRequest` - Scene or destination team not found. `403 Forbidden` - Caller is not authorized to transfer between these teams. `409 Conflict` - Scene is part of a project and cannot be transferred independently. `500 InternalServerError` - Unexpected server-side error.
   *
   * @tags Scenes
   * @name TransferCreate
   * @summary Transfer a scene to another team
   * @request POST:/scenes/{sceneId}/transfer
   * @secure
   */
  transferCreate = (
    sceneId: string,
    data: TransferRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/scenes/${sceneId}/transfer`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Fetches a list of accessors which are associated with the specified scene. **Restrictions:** - **Scene Validation**: The scene with the given `sceneId` must exist. If it doesn't, a `400 BadRequest` is returned with the `SceneNotFound` message. **Behavior:** - Retrieves all accessors (`SceneAccessors`) associated with the scene. - Converts each accessor to `SceneAccessorResponseDto` and returns the complete list. **Outcome:** - On success, returns HTTP `200 OK` with a list of accessors. - If the scene is not found, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`. Any authenticated user with access to the scene may call this endpoint. - For internal errors, returns HTTP `500 InternalServerError`.
   *
   * @tags Scenes
   * @name AccessorsList
   * @summary Get accessors for a specific scene
   * @request GET:/scenes/{sceneId}/accessors
   * @secure
   */
  accessorsList = (sceneId: string, params: RequestParams = {}) =>
    this.request<SceneAccessorResponseDto[], ProblemDetails | void>({
      path: `/scenes/${sceneId}/accessors`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Adds or replaces the list of accessors associated with the specified scene. **Restrictions:** - **Scene Validation**: The scene with the given `sceneId` must exist and must not be marked as deleted. If it doesn't exist, a `400 BadRequest` is returned with the `SceneNotFound` message. - **Input Validation**: If the request list is null, a `400 BadRequest` is returned with the `InvalidRequest` message. - **Location Access Type Rules**: If `AccessType` is `Location`, both `Latitude` and `Longitude` must be provided. Also, only `AnchorType.Image` is allowed for such entries. Violating items will be skipped. **Behavior:** - Deletes all existing accessors for the scene. - Validates and inserts each valid accessor from the provided list. - Geohash is calculated if latitude and longitude are present. - Each successfully added accessor is returned as `SceneAccessorResponseDto`. **Outcome:** - On success, returns HTTP `200 OK` with a list of newly created accessors. - If the scene is not found or the input is invalid, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`. Any authenticated user with access to the scene may call this endpoint. - For internal errors, returns HTTP `500 Internal Server Error`.
   *
   * @tags Scenes
   * @name AccessorsCreate
   * @summary Insert a range of accessors for a specific scene
   * @request POST:/scenes/{sceneId}/accessors
   * @secure
   */
  accessorsCreate = (
    sceneId: string,
    data: SceneAccessorRequestDto[],
    params: RequestParams = {},
  ) =>
    this.request<SceneAccessorResponseDto[], ProblemDetails | void>({
      path: `/scenes/${sceneId}/accessors`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Updates the specified accessor associated with a scene. **Restrictions:** - **Scene & Accessor Validation**: The accessor with the given `accessorsId` and `sceneId` must exist. If not found, a `400 BadRequest` is returned with the `NotFound` message. - **Request Body**: If the request body is null, a `400 BadRequest` is returned with the `InvalidRequest` message. - **AccessType.Location Rules**: If `AccessType` is `Location`, both `Latitude` and `Longitude` must be provided. Otherwise, a `400 BadRequest` with the `AddressNull` message is returned. **Behavior:** - Updates the existing accessor’s data with the new values provided. - If location data is present, calculates a new geohash. - If the access type is `Anywhere`, only specific properties (`Location`, `Geohash`, `Address`) are updated. - Otherwise, all fields are updated. **Outcome:** - On success, returns HTTP `200 OK` with the updated `SceneAccessorResponseDto`. - If the accessor is not found or the request is invalid, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`. Any authenticated user with access to the scene may call this endpoint. - For internal errors, returns HTTP `500 Internal Server Error`.
   *
   * @tags Scenes
   * @name AccessorsPartialUpdate
   * @summary Update a specific accessor for a scene
   * @request PATCH:/scenes/{sceneId}/accessors/{accessorsId}
   * @secure
   */
  accessorsPartialUpdate = (
    sceneId: string,
    accessorsId: string,
    data: SceneAccessorRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<SceneAccessorResponseDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}/accessors/${accessorsId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Removes the specified accessor associated with the given scene. **Restrictions:** - **Validation**: The accessor with the specified `accessorsId` must exist under the given `sceneId`. If not found, a `400 BadRequest` is returned with the `NotFound` message. **Behavior:** - Locates the accessor using `sceneId` and `accessorsId`. - If found, deletes the accessor from the database. **Outcome:** - On success, returns HTTP `204 No Content`. - If the accessor is not found, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`. Any authenticated user with access to the scene may call this endpoint. - For internal errors, returns HTTP `500 Internal Server Error`.
   *
   * @tags Scenes
   * @name AccessorsDelete
   * @summary Delete a specific accessor from a scene
   * @request DELETE:/scenes/{sceneId}/accessors/{accessorsId}
   * @secure
   */
  accessorsDelete = (
    sceneId: string,
    accessorsId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/scenes/${sceneId}/accessors/${accessorsId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Fetches the details of a single accessor associated with the specified scene. **Restrictions:** - **Validation**: The accessor must exist for the given `sceneId` and `accessorsId`. If not found, a `400 BadRequest` is returned with the `NotFound` message. **Behavior:** - Retrieves the accessor record from the database using the provided IDs. - Converts the data to `SceneAccessorResponseDto` and returns it. **Outcome:** - On success, returns HTTP `200 OK` with the accessor data. - If the accessor is not found, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`. Any authenticated user with access to the scene may call this endpoint. - For internal errors, returns HTTP `500 Internal Server Error`.
   *
   * @tags Scenes
   * @name AccessorsDetail
   * @summary Get a specific accessor for a scene
   * @request GET:/scenes/{sceneId}/accessors/{accessorsId}
   * @secure
   */
  accessorsDetail = (
    sceneId: string,
    accessorsId: string,
    params: RequestParams = {},
  ) =>
    this.request<SceneAccessorResponseDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}/accessors/${accessorsId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Hashes the upload and stores it at `trace-content/scenes/{sceneId}/assets/<slug>.<hash16>.<ext>`, returning the **relative** uri the scene document references it by. `<slug>` comes from this upload's file name and `<hash16>` is the first 16 hex characters of its SHA-256 (content model spec §2.1). **Restrictions:** - **Validation**: A non-empty `File` is required, and its type must be one the platform stores (the same allowlist every other upload path uses). - **Scene Validation**: The scene must exist and not be deleted. - **Permission**: The same `Editor`/`Owner` gate as `POST /{sceneId}/contents`. `Viewer`-only access returns `400 BadRequest` with `YouHaveNoPermission`; `SuperAdmin` bypasses it. **Behavior:** - Names are minted by the server and nothing else, and carry the hash of the bytes, so importing the same file twice writes once. A name collision is not an error: the response is `200 OK` with the same entry and `alreadyExisted: true`. - The returned `uri` is relative (`assets/<slug>.<hash16>.<ext>`) on purpose - a reader resolves it against the document's own URL, which is what lets a scene folder be copied, downloaded, zipped and re-uploaded with no rewriting. - The response also carries `name`, the uploaded part's file name, for the client to write into `files[k].name` - the human label storage never keeps (spec §2.1). On a dedupe hit it is **this** upload's name, not the name the bytes were first stored under. **Outcome:** - On success, returns HTTP `200 OK` with a `SceneFileResponseDto`. - If validation fails, the scene is not found, or the caller lacks edit permission, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`.
   *
   * @tags Scenes
   * @name FilesCreate
   * @summary Import a file into a scene's folder
   * @request POST:/scenes/{sceneId}/files
   * @secure
   */
  filesCreate = (
    sceneId: string,
    data: {
      /** @format binary */
      File?: File;
      /** @format uuid */
      TeamId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<SceneFileResponseDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}/files`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Redirects (`302`) to the file of the scene's **current** document whose `files[k].name` equals `{name}` - the human name, the one that was dropped in, not the stored one (content model spec §2.4). **This is "latest by plain name" at the API, with no mutable blob behind it.** Storage names are immutable and content-addressed (`assets/<slug>.<hash16>.<ext>`) precisely so a CDN can cache them forever and an old document still says which bytes it meant; the cost is that nobody can *type* one. This endpoint pays that cost at the API instead: it re-reads the row and its current document on every request, so what it answers moves when the scene is saved, while the blob it points at never does. **Readers never use it.** A document's `files[k].uri` is the resolver, and it is already the exact bytes that document meant. This is for tools, scripts and people: `curl` a model out of a scene by the name it was imported under. **Matching:** exact first over the whole document, then case-insensitive over the whole document; the first match wins. `{name}` = `scene.gltf` answers **the document itself** (the name the `.glz` bundle's root entry carries, §4). Only this scene folder's own files resolve: an entry naming a library asset (`/assets/{guid}/file`) or a foreign stream is an absolute reference rather than a file of this folder, and a name that only matches one of those is a `404`. A legacy scene row (`.zip`, `.glxf`, `.trace`, `.tracex`) has no folder and answers `404` for every name. **Caching:** identical to `GET /assets/{assetId}/file` - `Cache-Control: public, max-age=60`, a strong `ETag` (the target's version token), `Last-Modified` from the row, and `304` on `If-None-Match` / `If-Modified-Since`. **Permissions:** the scene's **read** gate - the same visibility `GET /{sceneId}/contents` applies, so an unpublished scene is not confirmed to a guest. **Returns:** `302 Found` - `Location` is the file's absolute url. `304 Not Modified` - the caller's validators still match; no `Location` is sent. **Error Codes:** `400 BadRequest` - the scene is not found or not visible to the caller. `401 Unauthorized` - User is not authenticated. `404 NotFound` - nothing in the scene's current document answers to that name.
   *
   * @tags Scenes
   * @name FilesDetail
   * @summary Follow a scene to one of its files by plain name
   * @request GET:/scenes/{sceneId}/files/{name}
   * @secure
   */
  filesDetail = (sceneId: string, name: string, params: RequestParams = {}) =>
    this.request<any, void | ProblemDetails>({
      path: `/scenes/${sceneId}/files/${name}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description The scene folder's retained documents, newest first (content model spec §2.8): `[ { version, url, createdAt, parent, current } ]`. **What a version is.** Every save writes a new immutable document into `trace-content/scenes/{sceneId}/` and repoints the row; the old ones stay for the retention window (`BlobSweep:HistoryDays`, default 30 days, and never fewer than the newest `BlobSweep:HistoryMinDocuments`, default 5). There is no version table - the folder is the history, and this enumerates it. - `version` is the document's full SHA-256, the same value the scene content row's `version` holds, and what `POST /{sceneId}/contents/rollback` names. - `parent` is the `version` of the document that was current when this one was written - the chain. `null` when there was none, or when the parent has already fallen out of the window. - `current` marks the one the row points at. - Legacy rows (`.zip`, `.glxf`, `.trace`, `.tracex` in `scene-content-files`) have no history and list as empty: they are overwritten in place and always were. **Permissions:** the scene's **read** gate - the same visibility `GET /{sceneId}/contents` applies, so an unpublished scene is not confirmed to a guest. **Returns:** `200 OK` - the versions, newest first. Possibly empty. **Error Codes:** `400 BadRequest` - the scene is not found or not visible to the caller. `401 Unauthorized` - User is not authenticated.
   *
   * @tags Scenes
   * @name ContentsHistoryList
   * @summary List a scene's saved versions
   * @request GET:/scenes/{sceneId}/contents/history
   * @secure
   */
  contentsHistoryList = (
    sceneId: string,
    query?: {
      /** @format uuid */
      teamId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ContentHistoryEntryDto[], ProblemDetails | void>({
      path: `/scenes/${sceneId}/contents/history`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Points the scene's content row back at a document the folder still holds (content model spec §2.8). Body: `{ "version": "<full sha256>", "teamId": "<guid>" }`. **A rollback is a repoint.** No document is written, no bytes move, and no `parent` is rewritten: the chain records what was *saved* and the row records what is *current*, so a rollback shows up as the pointer sitting on an older node. The next save stamps `parent` = the document you rolled back to, which leaves the abandoned branch listed until the window closes. **What is checked first**, in order, and any of them refuses without touching the row: - the version is still in the folder (`404` otherwise - it never was, or the retention window closed on it); - every relative file that document names is still there (`400` with `files: [ { index, authored, stored } ]`, `stored` null); - its manifest still validates (§2.5) - a **library asset it references may have been deleted since**, and that fails the rollback rather than dangling. The `400` message names the offending `files[i]` index and why. **Permissions:** a **save** - the same `Editor`/`Owner` gate as `POST /{sceneId}/contents` and `POST /{sceneId}/files`. **Returns:** `200 OK` - the version that is now current. The row's `url` and `version` both move to the document you rolled back to (v5.1, §2.4), so a subsequent `GET /{sceneId}/contents` returns it. Any retained document may be rolled back to, including one still stored under its pre-v5 name - the row holds the pointer, so it does not have to be one this API could have spelled. **Error Codes:** `400 BadRequest` - the scene is not found, the caller may not edit it, no version was given, the scene has no folder document at all, or the document can no longer be validated. `401 Unauthorized` - User is not authenticated. `404 NotFound` - the folder does not hold that version.
   *
   * @tags Scenes
   * @name ContentsRollbackCreate
   * @summary Roll a scene back to an earlier version
   * @request POST:/scenes/{sceneId}/contents/rollback
   * @secure
   */
  contentsRollbackCreate = (
    sceneId: string,
    data: ContentRollbackRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<ContentHistoryEntryDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}/contents/rollback`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Creates a new scene from an existing one: new rows, and a server-side copy of every blob in the source's content folder. **Restrictions:** - **Permission**: The caller must be able to edit the source scene, and must be a non-`Viewer` member of the team the copy is created for (defaults to the source's creator team). **Behavior:** - Blobs are copied server-side and each copy is **awaited to completion**; any failure aborts the whole copy rather than leaving a half-copied folder behind. - Documents are not rewritten. Their file uris are relative, so they resolve against the new folder unchanged. - The copy is always `UnPublished` and gets its own short code; it is never published by inheritance. **Outcome:** - On success, returns HTTP `200 OK` with the new `SceneResponseDto`. - If the scene is not found or the caller lacks permission, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`.
   *
   * @tags Scenes
   * @name CopyCreate
   * @summary Copy a scene
   * @request POST:/scenes/{sceneId}/copy
   * @secure
   */
  copyCreate = (
    sceneId: string,
    data: SceneCopyRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<SceneResponseDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}/copy`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Uploads and adds a new content entry to the specified scene. **Restrictions:** - **Validation**: A valid `File` must be included in the request. If the file is missing, a `400 BadRequest` is returned with the `InvalidRequest` message. - **Scene Validation**: The scene with the provided `sceneId` must exist. Otherwise, a `400 BadRequest` is returned with the `SceneNotFound` message. - **Permission**: Caller must have `Editor` or `Owner` permission on the scene via at least one of their teams. If `TeamId` is supplied on the request, only that team is consulted; otherwise the server resolves any team the caller belongs to that has edit access. `Viewer`-only access returns `400 BadRequest` with `YouHaveNoPermission`. `SuperAdmin` bypasses this check. **Behavior:** - Validates the request and checks the existence of the scene. - Creates a `SceneContent` entry with associated metadata. - Uploads the file, and records **where it went** in the row's `url` (v5.1, §2.4): container-relative, `trace-content/scenes/{sceneId}/scene.<hash16>.gltf` for a `.gltf` document and `scene-content-files/{contentId}.{ext}` for a legacy upload. `GET` returns that column made absolute against the blob endpoint; nothing re-derives it from `(sceneId, version, fileExtension)` any more. A row written before v5.1 whose `url` the backfill has not filled in returns `url: null` rather than a guess. - Commits the transaction to the database. **Outcome:** - On success, returns HTTP `200 OK` with the updated `SceneContentCollectionDto`. - If validation fails, the scene is not found, or the caller lacks edit permission, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`. - For internal errors, returns HTTP `500 Internal Server Error`.
   *
   * @tags Scenes
   * @name ContentsCreate
   * @summary Add content to a specific scene
   * @request POST:/scenes/{sceneId}/contents
   * @secure
   */
  contentsCreate = (
    sceneId: string,
    data: {
      /** @format binary */
      File?: File;
      Version?: string;
      Name?: string;
      AuthorId?: string;
      AuthorName?: string;
      /** @format double */
      Duration?: number;
      AvatarId?: string;
      Preview?: string;
      ContentType?: string;
      /** @format uuid */
      TeamId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<SceneContentCollectionDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}/contents`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
  /**
   * @description Fetches a collection of content items associated with the specified scene. **Restrictions:** - **Scene Validation**: The scene with the provided `sceneId` must exist and not be deleted. If it doesn't exist, a `400 BadRequest` is returned with the `SceneNotFound` message. - **ReferenceContent gate**: `ReferenceContent` items are an editor-only extension and are stripped from the response by default. Pass `includeReferenceContent=true` to include them — this requires the caller to have `Editor` or `Owner` permission on the scene via at least one of their teams. `teamId` may be supplied to scope the check; otherwise the server resolves any qualifying team. `Viewer`-only access returns `400 BadRequest` with `YouHaveNoPermission`. `SuperAdmin` bypasses this check. **Behavior:** - Retrieves the scene and its associated `SceneContents`. - Returns the latest `RootContent`, then (if requested and authorized) the latest `ReferenceContent`, then all `Recording` items. **Outcome:** - On success, returns HTTP `200 OK` with the collection of content. - If the scene is not found or the caller lacks edit permission when `includeReferenceContent=true`, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`. - For internal errors, returns HTTP `500 Internal ServerError`.
   *
   * @tags Scenes
   * @name ContentsList
   * @summary Get contents for a specific scene
   * @request GET:/scenes/{sceneId}/contents
   * @secure
   */
  contentsList = (
    sceneId: string,
    query?: {
      /** @default false */
      includeReferenceContent?: boolean;
      /** @format uuid */
      teamId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<SceneContentCollectionDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}/contents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Deletes a specific content entry associated with the given scene. **Restrictions:** - **Scene Content Validation**: The content with the provided `contentId` must exist under the specified `sceneId`. Otherwise, a `400 BadRequest` is returned with the `NotFound` message. - **Permission**: Caller must have `Editor` or `Owner` permission on the scene via at least one of the teams they belong to. The server resolves the caller's team membership automatically. `Viewer`-only access returns `400 BadRequest` with `YouHaveNoPermission`. `SuperAdmin` bypasses this check. **Behavior:** - Validates the existence of the content within the scene. - Deletes the `SceneContent` record from the database. - Commits the deletion. **Outcome:** - On success, returns HTTP `204 No Content`. - If content is not found or caller lacks edit permission, returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`. - For any internal issues, returns HTTP `500 Internal Server Error`.
   *
   * @tags Scenes
   * @name ContentsDelete
   * @summary Delete content from a specific scene
   * @request DELETE:/scenes/{sceneId}/contents/{contentId}
   * @secure
   */
  contentsDelete = (
    sceneId: string,
    contentId: string,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/scenes/${sceneId}/contents/${contentId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description Fetches the details of a single content associated with the specified scene. **Restrictions:** - **Validation**: The content must exist for the given `sceneId` and `contentId`. If not found, a `400 BadRequest` is returned with the `SceneContentNotFound` message. - **ReferenceContent gate**: If the requested content is `ReferenceContent`, the caller must have `Editor` or `Owner` permission on the scene via at least one of their teams. `teamId` may be supplied to scope the check. Callers without edit access receive the same `SceneContentNotFound` response as for missing content (avoids leaking the existence of editor-only content to viewers). `SuperAdmin` bypasses this check. **Behavior:** - Retrieves the content record from the database using the provided IDs. - Converts the data to `SceneContentResponseDto` and returns it. **Outcome:** - On success, returns HTTP `200 OK` with the content data. - If the content is not found (or is ReferenceContent without edit permission), returns HTTP `400 BadRequest`. - If not authenticated, returns HTTP `401 Unauthorized`. - For internal errors, returns HTTP `500 Internal Server Error`.
   *
   * @tags Scenes
   * @name ContentsDetail
   * @summary Get a specific content for a scene
   * @request GET:/scenes/{sceneId}/contents/{contentId}
   * @secure
   */
  contentsDetail = (
    sceneId: string,
    contentId: string,
    query?: {
      /** @format uuid */
      teamId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<SceneContentResponseDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}/contents/${contentId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Retrieves a list of all users, teams, and pending invitations associated with a given scene, including their permissions. **Behavior:** - Validates the existence of the scene. - If the scene doesn't exist, throws a `BadRequestException` with message `SceneNotFound`. - Fetches associated teams, users, and user invitations linked to the scene. - Combines and returns all permission-related data in a `ProjectAndScenePermissionsResponseDto`. **Returns:** - HTTP `200 OK` with scene permissions data. - HTTP `400 BadRequest` if the scene is not found. - HTTP `401 Unauthorized` if not authenticated. Any authenticated user with access to the scene may call this endpoint. - HTTP `500 InternalServerError` for any unhandled issues.
   *
   * @tags Scenes
   * @name MembersList
   * @summary Get scene share permissions
   * @request GET:/scenes/{sceneId}/members
   * @secure
   */
  membersList = (sceneId: string, params: RequestParams = {}) =>
    this.request<ProjectAndScenePermissionsResponseDto, ProblemDetails | void>({
      path: `/scenes/${sceneId}/members`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Shares a scene with specified teams by adding members, managing access, and updating permissions. **Behavior:** - Validates the existence of the scene. - If the scene doesn't exist, throws a `BadRequestException` with message `SceneNotFound`. - Verifies the user's permissions to share the scene. - If the user lacks permissions, throws a `BadRequestException` with message `YouHaveNoPermission`. - Manages the members, access, and permissions for the specified teams. **Returns:** - HTTP `204 No Content` on successful sharing of the scene with teams. - HTTP `400 BadRequest` if the scene doesn't exist or the user lacks permission. - HTTP `401 Unauthorized` if not authenticated. Requires Editor or Owner permission (non-Viewer) in the team-scene relationship. Permission failures return `400 BadRequest`. - HTTP `500 InternalServerError` for any unhandled issues.
   *
   * @tags Scenes
   * @name MembersTeamsCreate
   * @summary Share scene with teams
   * @request POST:/scenes/{sceneId}/members/teams
   * @secure
   */
  membersTeamsCreate = (
    sceneId: string,
    data: TeamProjectShareRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/scenes/${sceneId}/members/teams`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Shares a scene with specified users by managing their permissions and access. **Behavior:** - Validates the existence of the scene. - If the scene doesn't exist, throws a `BadRequestException` with message `SceneNotFound`. - Verifies the user's permissions to share the scene with others. - If the user lacks permission, throws a `BadRequestException` with message `YouHaveNoPermission`. - Manages the access and permissions for the specified users. **Returns:** - HTTP `204 No Content` on successful sharing of the scene with users. - HTTP `400 BadRequest` if the scene doesn't exist or the user lacks permission. - HTTP `401 Unauthorized` if not authenticated. Requires Editor or Owner permission (non-Viewer) in the team-scene relationship. Permission failures return `400 BadRequest`. - HTTP `500 InternalServerError` for any unhandled issues.
   *
   * @tags Scenes
   * @name MembersUsersCreate
   * @summary Share scene with users
   * @request POST:/scenes/{sceneId}/members/users
   * @secure
   */
  membersUsersCreate = (
    sceneId: string,
    data: UserSceneShareRequestDto,
    params: RequestParams = {},
  ) =>
    this.request<void, ProblemDetails | void>({
      path: `/scenes/${sceneId}/members/users`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description This endpoint updates the order (index) of existing scenes. Each scene is identified by its `Id`, and a new `Index` is provided for sorting. **Requirements:** - The request must include a list of scene IDs with their corresponding new indices.
   *
   * @tags Scenes
   * @name OrderPartialUpdate
   * @summary Reorder existing scenes
   * @request PATCH:/scenes/order
   * @secure
   */
  orderPartialUpdate = (data: OrderRequestDto[], params: RequestParams = {}) =>
    this.request<void, ProblemDetails | void>({
      path: `/scenes/order`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
